var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFuse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21086_45705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0741 2H13.7541C11.081 2 8.91406 4.16694 8.91406 6.84V29.16C8.91406 31.8331 11.081 34 13.7541 34H36.0741C38.7471 34 40.9141 31.8331 40.9141 29.16V6.84C40.9141 4.16694 38.7471 2 36.0741 2Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3341 6H16.4941C15.0692 6 13.9141 7.15511 13.9141 8.58V25.42C13.9141 26.8449 15.0692 28 16.4941 28H33.3341C34.759 28 35.9141 26.8449 35.9141 25.42V8.58C35.9141 7.15511 34.759 6 33.3341 6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9639 12H20.1943V18.0417H22.9639V12Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1944 12H27.4248V18.0417H30.1944V12Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.425 22C27.425 21.3493 27.1889 20.7252 26.7686 20.265C26.3483 19.8048 25.7783 19.5463 25.1839 19.5463C24.5896 19.5463 24.0195 19.8048 23.5993 20.265C23.179 20.7252 22.9429 21.3493 22.9429 22H27.425Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9141 36.3798V41.6011C22.9141 42.1788 22.7937 42.7508 22.5599 43.2845C22.326 43.8182 21.9833 44.3031 21.5512 44.7116C21.1191 45.1201 20.6061 45.4441 20.0416 45.6652C19.477 45.8862 18.8719 46 18.2609 46H8.91406V32H18.2811C19.5082 32.005 20.6835 32.4681 21.5512 33.2884C22.4189 34.1086 22.9087 35.2197 22.9141 36.3798Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91406 38V36H2.91406V38H8.91406Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91406 42V40H2.91406V42H8.91406Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9141 42V36H22.9141V42H26.9141Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9141 40V38H26.9141V40H46.9141Z",
    fill: "#8E8CEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21086_45705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.914062)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuse);
export default __webpack_public_path__ + "static/media/fuse.a110dfd104f4a9ba2abdaaa497cd2b2c.svg";
export { ForwardRef as ReactComponent };